export default "__VITE_ASSET__a2750e9f__"